// extracted by mini-css-extract-plugin
module.exports = {"adressInfo":"address_adressInfo__1pjAC","formSelect":"address_formSelect__3hLXt"};